import { paying, SUBSCRIPTION_STATUS_LABEL, type BillingFeature, type PlatformBilling } from '../lib/billing';
import { formatDate } from '../lib/format';
import { Badge } from './ui';

const SHORT_LABEL: Record<BillingFeature, string> = {
  FACILITIES: 'Facilities',
  GOOGLE_PROVISIONING: 'Provisioning',
  BLACKBAUD_BILLING: 'Billing Mgmt',
  FREQUENT_SYNC: 'Frequent sync',
  DEVICE_LOCATION: 'Chromebook location',
};

/** A school's plan on the Schools list: how it's paid for, and its add-ons. */
export function PlanCell({ billing }: { billing: PlatformBilling | null }) {
  const trial = billing?.trialEndsAt && new Date(billing.trialEndsAt) > new Date() ? billing.trialEndsAt : null;
  const status = billing?.subscriptionStatus ?? null;
  const annual = (billing?.annualAddOns ?? []).filter((addOn) => paying(addOn.status)).map((addOn) => addOn.feature);
  const addOns = [...(billing?.addOns ?? []), ...annual, ...(billing?.grantedAddOns ?? []).filter((feature) => !billing?.addOns.includes(feature))];
  return (
    <div className="flex flex-col items-start gap-1">
      {billing?.complimentary ? (
        <Badge tone="violet">Complimentary</Badge>
      ) : status ? (
        <Badge tone={paying(status) ? (status === 'PAST_DUE' ? 'amber' : 'green') : 'red'}>{SUBSCRIPTION_STATUS_LABEL[status]}</Badge>
      ) : trial ? (
        <Badge tone="blue">
          {billing?.trialKind === 'SIGN_UP' ? 'Sign-up trial' : 'Trial'} to {formatDate(trial)}
        </Badge>
      ) : (
        <Badge>No subscription</Badge>
      )}
      {billing?.deletesAt && <span className="text-xs font-medium text-red-700">Deletes {formatDate(billing.deletesAt)}</span>}
      {status && trial && <span className="text-xs text-slate-500">Trial to {formatDate(trial)}</span>}
      {addOns.length > 0 && (
        <span className="text-xs text-slate-500">
          {addOns.map((feature) => `${SHORT_LABEL[feature]}${billing?.grantedAddOns.includes(feature) ? ' (free)' : ''}`).join(', ')}
        </span>
      )}
    </div>
  );
}
